(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'react-emotion', './index.css', './icons/UploadIcon.svg', './icons/EmailIcon.svg', './icons/DesktopIcon.svg', './icons/SettingsIcon.svg', './icons/ConfirmIcon.svg', './icons/DownloadIcon.svg', './icons/CheckListIcon.svg', './icons/LightUploadIcon.svg', './icons/PenAndPaperIcon.svg'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('react-emotion'), require('./index.css'), require('./icons/UploadIcon.svg'), require('./icons/EmailIcon.svg'), require('./icons/DesktopIcon.svg'), require('./icons/SettingsIcon.svg'), require('./icons/ConfirmIcon.svg'), require('./icons/DownloadIcon.svg'), require('./icons/CheckListIcon.svg'), require('./icons/LightUploadIcon.svg'), require('./icons/PenAndPaperIcon.svg'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.reactEmotion, global.index, global.UploadIcon, global.EmailIcon, global.DesktopIcon, global.SettingsIcon, global.ConfirmIcon, global.DownloadIcon, global.CheckListIcon, global.LightUploadIcon, global.PenAndPaperIcon);
    global.Tab = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _reactEmotion, _index, _UploadIcon, _EmailIcon, _DesktopIcon, _SettingsIcon, _ConfirmIcon, _DownloadIcon, _CheckListIcon, _LightUploadIcon, _PenAndPaperIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _index2 = _interopRequireDefault(_index);

  var _UploadIcon2 = _interopRequireDefault(_UploadIcon);

  var _EmailIcon2 = _interopRequireDefault(_EmailIcon);

  var _DesktopIcon2 = _interopRequireDefault(_DesktopIcon);

  var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);

  var _ConfirmIcon2 = _interopRequireDefault(_ConfirmIcon);

  var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);

  var _CheckListIcon2 = _interopRequireDefault(_CheckListIcon);

  var _LightUploadIcon2 = _interopRequireDefault(_LightUploadIcon);

  var _PenAndPaperIcon2 = _interopRequireDefault(_PenAndPaperIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var tabberIcons = {
    Upload: _react2.default.createElement(_UploadIcon2.default, null),
    Email: _react2.default.createElement(_EmailIcon2.default, null),
    Desktop: _react2.default.createElement(_DesktopIcon2.default, null),
    Settings: _react2.default.createElement(_SettingsIcon2.default, null),
    Confirm: _react2.default.createElement(_ConfirmIcon2.default, null),
    Download: _react2.default.createElement(_DownloadIcon2.default, null),
    CheckList: _react2.default.createElement(_CheckListIcon2.default, null),
    LightUpload: _react2.default.createElement(_LightUploadIcon2.default, null),
    PenAndPaper: _react2.default.createElement(_PenAndPaperIcon2.default, null)
  };

  var getTabberIcon = function getTabberIcon(icon) {
    return tabberIcons[icon];
  };

  var Tab = function (_Component) {
    (0, _inherits3.default)(Tab, _Component);

    function Tab() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Tab);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
        tabHovered: false
      }, _this.onMouseEnter = function () {
        return _this.setState({ tabHovered: true });
      }, _this.onMouseLeave = function () {
        return _this.setState({ tabHovered: false });
      }, _this.getClassNamesForTab = function (isActive, isLocked) {
        var activeClasses = isActive ? _index2.default.highlighterActive : _index2.default.highlighterInactive;

        if (isActive && !isLocked) {
          return activeClasses;
        }

        var hoverClasses = _this.state.tabHovered && !isLocked ? _index2.default.highlighterGraybar : undefined;

        return (0, _reactEmotion.cx)(activeClasses, hoverClasses);
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Tab.prototype.render = function render() {
      var _props = this.props,
          icon = _props.icon,
          label = _props.label,
          labelSubText = _props.labelSubText,
          onClickHandler = _props.onClickHandler,
          lockedOnClickHandler = _props.lockedOnClickHandler,
          isActive = _props.isActive,
          tabWidth = _props.tabWidth,
          isLocked = _props.isLocked,
          dataTestId = _props.dataTestId;


      var lockedNoHover = isLocked ? _index2.default.lockedNoHover : undefined;
      var lockedOpacity = isLocked ? _index2.default.lockedOpacity : undefined;

      return _react2.default.createElement(
        'div',
        {
          className: (0, _reactEmotion.cx)(_index2.default.rounded, tabWidth, 'tabber-tab', lockedNoHover),
          onClick: isLocked ? lockedOnClickHandler || null : onClickHandler,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          'data-testid': dataTestId
        },
        _react2.default.createElement('div', { className: this.getClassNamesForTab(isActive, isLocked) }),
        _react2.default.createElement(
          'div',
          { className: _index2.default.content },
          _react2.default.createElement(
            'div',
            { className: lockedOpacity },
            getTabberIcon(icon)
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _reactEmotion.cx)(_index2.default.labelWrapper, _index2.default.labelWrapperCenter) },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: (0, _reactEmotion.cx)(_index2.default.label, lockedOpacity) },
                label
              ),
              labelSubText && _react2.default.createElement(
                'span',
                { className: (0, _reactEmotion.cx)(_index2.default.labelSubText, lockedOpacity) },
                '\xA0',
                labelSubText
              )
            )
          )
        )
      );
    };

    return Tab;
  }(_react.Component);

  exports.default = Tab;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/Tab.js
// module id = 536
// module chunks = 1